export var getTabId = function getTabId(value) {
  return "tab".concat(value);
};
export var getPanelId = function getPanelId(value) {
  return "panel".concat(value);
};